var portfolioEdit = {
	confirmBtn: "Ok",
	cancelBtn: "Abbrechen",
	title: "Virtuelles Portfolio bearbeiten",
	nameInputLabel: "Portfolioname",
	nameInputPlaceholder: "Bitte geben Sie einen Namen ein",
	nameInputTip: "Maximal 100 Zeichen – Gültige Zeichen: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	currencyInputLabel: "Basiswährung des Portfolios",
	currencyInputPlaceholder: "Bitte wählen Sie eine Währung",
	limitExceededMessage: "Portfoliolimit überschritten",
	currencies: {
		euro: "Euro",
		usd: "US-Dollar",
		chf: "Schweizer Franken",
		gbp: "Britisches Pfund",
		jpy: "Japanischer Yen",
		cad: "Kanadischer Dollar"
	},
	validationErrors: {
		name: {
			invalidInput: "Name ist ungültig. Maximal 100 Zeichen – Gültige Zeichen: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var de = {
	portfolioEdit: portfolioEdit
};

export { de as default, portfolioEdit };
